import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-user',
  templateUrl: './modify-user.component.html',
  styleUrls: ['./modify-user.component.css']
})
export class ModifyUserComponent implements OnInit {

  data: any;
  editForm: any | FormGroup;
  modelSubtitle = false
  users:any = []
  checked = false
  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  userParameters:any = []
  userId = ''
  paramData:any = []
  roles:any = []
  cid:any
  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  userTypes:any = []
  searchUser = ""
  userParams:any = []
  usersWithoutCustomers:any = []


  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllRoles()
    this.getParamByType()
    // this.getParamsData()
    this.getUsersWithoutCustomers()

    this.getParam()
    this.getAllUsers(this.pageNumber,this.recordsPerPage)
    this.editForm = this.fb.group({
      userName: [''],
      userMobileNo: [''],
      userEmail: [''],
      id: [''],
      userType:[''],
      reportsTo:['']

    })


    // this.paramForm = this.fb.group({
    //   paramObj:this.fb.array([])
    // }) 
    // this.addInfoObject()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event - 1;
    this.pageNumber1 = event;

    if(this.searchUser != ""){
      this.searchCustomer(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllUsers(this.pageNumber,this.recordsPerPage);
    }
  }

  // get paramArr(){
  //   return this.paramForm.get('paramObj') as FormArray;
  // }

  // paramObject(){
  //   return this.fb.group({
  //     "key": [''],
  //     "value": [''],
  //   })
  //  }
  
  //  addInfoObject(){
  //   // this.infoArr.clear()
  //   this.paramArr.push(this.paramObject())
  //  }

  //  removeParamObject(index: number){
  //   this.paramArr.removeAt(index)
  //  }

    // addParam(){
    //   if(this.userParameters.length == 0){
    //     let body = {
    //       "userId": Number(this.userId),
    //       "userParam": this.paramForm.get('paramObj').value
    //     }
    //     console.log(body)
    //     this.generic_service.addUserParameter(body).subscribe(
    //       (response:any)=>{
    //         this.getUserParameter(this.userId)
    //         console.log(response)
    //         this.paramArr.clear()
    //         this.addInfoObject()
    //       },
    //       (error:any)=> {
    //         console.log(error)
    //       }
    //     )
    //   }else{
    //     let body = this.paramForm.get('paramObj').value
    //     console.log(body)
    //     this.generic_service.addUserParameterByUserId(this.userId,body).subscribe(
    //       (response:any)=>{
    //         this.getUserParameter(this.userId)
    //         console.log(response)
    //         this.paramArr.clear()
    //         this.addInfoObject()
    //         this.editForm.clear()

    //       },
    //       (error:any)=> {
    //         console.log(error)
    //       }
    //     )
    //   }



    // }

    updateUser(){

      let keyValues: any = []

      for(let i = 0; i < this.userParams.length;i++) {
        keyValues.push(
          {
            "key": this.userParams[i].name,
            "value": this.userParams[i].value
          }
        )
      }
    let body: any = {
      "id": this.editForm.get('id').value,
      "version": 0,
      "isActive": true,
      "description": "",
      "userId":this.userId,
      "userType": String(this.editForm.get('userType').value),
      "userName": String(this.editForm.get('userName').value),
      "userMobileNo": String(this.editForm.get('userMobileNo').value),
      "userEmail": String(this.editForm.get('userEmail').value),
      "password":  "",
      "imageURL": "",
      "otp": "",
      "otpGenerateDateTime": 0,
      "keyValues": keyValues,
      "cid": this.cid
    }


    if(this.editForm.get('reportsTo').value != null && this.editForm.get('reportsTo').value != ""){
      body.reportsTo = Number(this.editForm.get('reportsTo').value)
    }

    console.log(body)
    this.generic_service.updateUser(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllUsers(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Updated");
        this.cancelModel()
        this.getParamByType()
        // this.editForm.clear()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllUsers(pageNumber:any,recordsPerPage:any){
    this.generic_service.getAllUsers(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response);
        let arr = []
        for(var i=0; i<response.response.userList.length; i++){
          if(response.response.userList[i].userType.toLowerCase() != 'su'){
            arr.push(response.response.userList[i])
          }
        }
        this.users = arr;
        this.totalRecords = response.response.totalRecords

        console.log(this.users)
      }
    )
  }

  getUserById(id:any){
    this.userId = id
    this.generic_service.getUserById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          userName: response.response.userName,
          userType: response.response.userType,
          userMobileNo: response.response.userMobileNo,
          userEmail: response.response.userEmail,
          password: response.response.password,
          id: response.response.id,
          reportsTo: response.response.reportsTo
        })

        if(response.response.userParameters){
          for(var i=0; i<response.response.userParameters.length; i++){
            for(var j=0; j<this.userParams.length; j++){
              if(response.response.userParameters[i].key == this.userParams[j].name){
                this.userParams[j].value = response.response.userParameters[i].value
              }
            }
          }
        }

        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }


  // open() {
  //   this.modelSubtitle = true;
  // }

  // close() {
  //   this.modelSubtitle = false;
  //   this.name = ""
  //   this.version = ""
  //   this.isActive = false
  // }

  // getUserParameter(userId:any){
  //   this.userId = userId
  //   this.generic_service.getUserParameterByUserId(userId).subscribe(
  //     (response:any)=>{
  //       this.userParameters = []
  //       console.log(response);
  //       this.userParameters = response.response.userParam;
  //     },
  //     (error:any)=>{
  //       this.userParameters = []
  //       console.log(error)
  //     }
  //   )
  // }

  // getParamsData(){
  //   this.generic_service.getParams().subscribe(
  //     (res:any)=> {
  //       console.log(res)
  //       this.paramData = res.response
  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }

  getAllRoles(){
    this.generic_service.getAllRoles().subscribe(
      (response:any)=>{
        console.log(response)

        let arr = []
        for(var i=0; i<response.response.length; i++){
          if(response.response[i].roleName.toLowerCase() != 'su'){
            arr.push(response.response[i])
          }
        }
        console.log(response)
        this.roles = arr
        console.log(this.roles)

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


  searchCustomer(pageNumber: any,recordsPerPage: any){
    if(this.searchUser != ""){
      this.generic_service.searchCustomer(this.searchUser,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          let arr = []
          for(var i=0; i<response.response.userList.length; i++){
            if(response.response.userList[i].userType.toLowerCase() != 'su'){
              arr.push(response.response.userList[i])
            }
          }
          this.users = arr;
          this.totalRecords = response.response.totalRecords
  
          console.log(this.users)
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllUsers(this.pageNumber,this.recordsPerPage)
    }

  }


  getParamByType(){
    let paramType = "USERPARAMS"
    this.generic_service.getParamByType(paramType).subscribe(
      (response:any)=>{
        console.log(response);
        this.userParams = []
        for(let key of response.response){
          if(key.boxType != null && key.boxType != "" && key.boxType != undefined){
            let obj = {
              name: key.name,
              boxType: key.boxType,
              isMandatory: key.isMandatory,
              possibleValue: key.possibleValue,
              value: "",
            }
            this.userParams.push(obj);
          }
        }
        console.log(this.userParams);

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getParam(){
    let paramType = "USERTYPE"
    this.generic_service.getParamByType(paramType).subscribe(
      (response:any)=>{
        console.log(response);
        for(let key of response.response){
          this.userTypes = key.possibleValue;
        }
        console.log(this.userTypes);

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersWithoutCustomers = res.response;
      }
    )
  }
}